import { render, staticRenderFns } from "./PrivacyAndSecuritySection.vue?vue&type=template&id=3e57dd16"
import script from "./PrivacyAndSecuritySection.vue?vue&type=script&lang=js"
export * from "./PrivacyAndSecuritySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports